import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ABAS_DEFAULT, useAppSelector } from '@monorepo-web/logic-extrato';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';

import 'jspdf-autotable';
import 'svg2pdf.js'
import LoadingModal from '../LoadingModal';
import './style.css';
import '../../../assets/fonts/OpenSans-Regular-normal'
import '../../../assets/fonts/OpenSans-Bold-bold'

import { desenharCapaPDF } from './Pages/CapaPDF'
import { desenharDisclaimerPDF } from './Pages/DisclaimerPDF'
import { desenharFooterPDF } from './Pages/FooterPDF'
import { gerarGraficos } from './Biblioteca/GerarGraficos';
import GerarPaginas from './Biblioteca/GerarPaginas';
import { ComponentPDF, docJSPDF, funcoesPDF, helperPDF } from '@monorepo-web/pdf-generator';
import { desenharContracapaPDF } from './Pages/ContracapaPDF';
import { gerarTabelas } from './Biblioteca/GerarTabelas';
import { StructurePDF } from './Pages/StructurePDF';
import { initialStatePageData, IPageData } from './Pages/IPageData';

export default function GerarPDFTodos2(props: any) {
  const theme = useTheme();
  const { state, search } = useLocation();
  const navigate = useNavigate();
  const [
    params,
    preferenceImagem,
    preferenceCustomizacao,
    preferenceImagemAPI,
    preferenceLiberacao,
    preferenceLayoutPDF,
    obj_datas,
    carteiraList,
    carteira,
    carteiraCapaPDF,
  ] = useAppSelector((state) => [
    state.preference.params,
    state.preference.preferenceStyle.imagem,
    state.preference.preferenceStyle.customizacao,
    state.preference.preferenceStyle.imagemAPI,
    state.preference.preferenceStyle.liberacao,
    state.preference.preferenceStyle.layoutPDF,
    state.resumoCart.obj_datas,
    state.preference.carteiraList,
    state.preference.params.carteira,
    state.capaPDF.carteiraCapaPDF,
  ]);

  // obtem unidade monetária
  const moneyPrefix = helperPDF.getMoneyPrefix(carteiraList, carteira);

  // indica se o PDF já foi gerado
  const [isPDFCreated, setIsPDFCreated] = useState<boolean>(false);

  // guarda os dados das tabelas e graficos de todas as paginas
  const [pageData, setPageData] = useState<IPageData>(initialStatePageData);
  // indica se todos os dados já carregaram
  const [isLoadedPageData, setIsLoadedPageData] = useState<boolean>(false);

  const abas = preferenceLiberacao?.abas ?? ABAS_DEFAULT;

  useEffect(() => {
    let allDataLoaded = true;
    for (const page of abas) {    // verifica se todas as páginas já carregaram
      if (page in pageData && !pageData[page as keyof typeof pageData]) {
        allDataLoaded = false;
      }
    }
    if (allDataLoaded) {
      setIsLoadedPageData(true);
    }
  }, [pageData]);

  const [docObj, structurePDF, config] = React.useMemo(() => {
    const docObj = new docJSPDF(theme, preferenceCustomizacao?.PDF_footerTopo, preferenceCustomizacao?.PDF_useCellPadding);
    const layoutPaginas = preferenceLayoutPDF?.layoutPaginas ?? abas;
    const structurePDF = new StructurePDF(docObj, layoutPaginas);
    const config = structurePDF.getConfig(preferenceLayoutPDF, preferenceCustomizacao);
    return [docObj, structurePDF, config];
  }, [theme, preferenceCustomizacao, preferenceLayoutPDF, abas]);

  // Elemento React dos gráficos
  const [graficos, setGraficos] = useState<Record<string, React.ReactNode> | null>(null);
  // ComponentPDF das tabelas
  const [tabelas, setTabelas] = useState<Record<string, ComponentPDF | null>>({});
  // ComponentPDF dos gráficos
  const [graficosComponent, setGraficosComponent] = useState<Record<string, ComponentPDF | ComponentPDF[]>>({});
  // Indica se todos os gráficos carregaram
  const [allLoaded, setAllLoaded] = useState<boolean>(false);

  const sendComponent = (id: string, html: any) => {
    setGraficosComponent((prevGraph: any) => ({
      ...prevGraph,
      [id]: html,
    }));
  }

  // Quando carregar todos os dados, gera as tabelas e gráficos
  useEffect(() => {
    if (isLoadedPageData) {
      setGraficos(gerarGraficos(pageData, theme, docObj, config, sendComponent, preferenceCustomizacao, moneyPrefix));
      setTabelas(gerarTabelas(pageData, theme, docObj, config, preferenceCustomizacao, moneyPrefix));
    }
  }, [isLoadedPageData])

  // verifca se os gráficos já carregaram
  useEffect(() => {
    if (graficos) {
      const isLoadedAllGraphs = Object.keys(graficos).every((id) => graficosComponent[id]);
      setAllLoaded(isLoadedAllGraphs);
    }
  }, [graficosComponent, graficos]);

  async function gerarPDF() {
    // datas formatadas
    const datasPDF = helperPDF.generateDatasPDF(obj_datas);

    // alias da carteira
    const alias_portfolio = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === params.carteira?.toUpperCase())[0].alias_nome_portfolio;

    // só mostra o disclaimer da carteiraList se possuir um PDF_disclaimer cadastrado na preference_whitelabel
    let disclaimer = preferenceCustomizacao?.PDF_disclaimer ?? null;
    if (disclaimer) {
      const disclaimerCarteiraList = carteiraList.find((item) => item.nome_portfolio.toUpperCase() === carteira?.toUpperCase())?.disclaimer;
      // Se houver disclaimer na carteiraList, utiliza no lugar do disclaimer da preference_whitelabel
      if (disclaimerCarteiraList) {
        disclaimer = disclaimerCarteiraList;
      }
    }

    // desenha a capa do PDF
    if (preferenceImagemAPI?.CapaPDF) {
      desenharCapaPDF(docObj.doc, theme, alias_portfolio ?? carteira, datasPDF.datasFim, preferenceCustomizacao, preferenceImagemAPI?.CapaPDF);
    }

    // desenha o disclaimer após a capa do PDF
    if (disclaimer && preferenceCustomizacao?.PDF_disclaimerPosicao === 'primeira') {
      desenharDisclaimerPDF(docObj.doc, theme, disclaimer, preferenceCustomizacao?.PDF_disclaimerSize ?? theme.mdFontSizePDF, false);
    }

    // obtem um array ordenado dos Componentes do PDF
    const componentsPDF = structurePDF.processComponents({ ...graficosComponent, ...tabelas });
    // desenha tabelas e gráficos no PDF
    await funcoesPDF.desenhaPDF(docObj, componentsPDF);

    // desenha o disclaimer na última página
    if (disclaimer && preferenceCustomizacao?.PDF_disclaimerPosicao === 'ultima') {
      desenharDisclaimerPDF(docObj.doc, theme, disclaimer, preferenceCustomizacao?.PDF_disclaimerSize ?? theme.mdFontSizePDF, true);
    }

    // desenha o footer para todas as páginas (menos contracapa)
    if (preferenceImagemAPI?.LogoPDF) {
      desenharFooterPDF(docObj.doc, theme, alias_portfolio ?? carteira, datasPDF, preferenceCustomizacao, preferenceImagemAPI?.LogoPDF, preferenceImagem);
    }

    // desenha a imagem da contracapa
    if (preferenceImagemAPI?.ContracapaPDF) {
      desenharContracapaPDF(docObj.doc, preferenceImagemAPI?.ContracapaPDF);
    }

    let nomePDF = ''
    if (obj_datas?.data_ini && obj_datas?.data_fim) {
      const nome_arquivo = `Extrato_${carteira + datasPDF.data_iniPDF + datasPDF.data_fimPDF + datasPDF.dataElaboracao}.pdf`;
      const prefix = props.isViaURL && (window as any).env.REACT_APP_PDFNAME ? `${(window as any).env.REACT_APP_PDFNAME}.` : '';  // adicionar prefixo com o nome do cliente(Utilizado no agendamento para evitar nomes duplicados)
      nomePDF = prefix + nome_arquivo;
    } else if (datasPDF.dataElaboracao) {
      nomePDF = 'Extrato' + datasPDF.dataElaboracao + '.pdf';
    } else {
      nomePDF = 'Extrato.pdf';
    }
    if (carteiraCapaPDF) {
      if (docObj.doc.getNumberOfPages() > 1) docObj.doc.deletePage(1); // Remove capa velha
      const docArrayBuffer = docObj.doc.output('arraybuffer');
      funcoesPDF.pdfCarteiraCustom([carteiraCapaPDF, docArrayBuffer], nomePDF);
    } else {
      docObj.doc.save(nomePDF);
    }
    setIsPDFCreated(true);
    const url = `${state}${carteira !== params.carteira ? '' : search}`;
    if (state && url) {
      navigate(url);
    }
    return;
  }
  useEffect(() => {
    if (allLoaded) {
      gerarPDF();
    }
  }, [allLoaded])

  return <>
    {isPDFCreated ? null : <LoadingModal loading={!isPDFCreated} showMinimizar={false} />}
    {!abas ? null : <GerarPaginas setPageData={setPageData} abas={abas} moneyPrefix={moneyPrefix} />}
    <div style={{ visibility: 'hidden' }}>
      {graficos && Object.keys(graficos).length > 0 ? (
        Object.entries(graficos).map(([id, component]) => (
          <div key={id}>{component}</div>
        ))
      ) : null}
    </div>
  </>
}
